import { render, staticRenderFns } from "./SportEventInfo.vue?vue&type=template&id=5cd56e8a&"
import script from "./SportEventInfo.vue?vue&type=script&lang=js&"
export * from "./SportEventInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports